import { AgentProfileAskQuestionProps } from 'sly/agentsAgentPage/AgentProfilePage/AgentProfilePageSummaryWrapper/AgentProfilePageSummary/AgentProfileText/AgentProfileAskQuestion/AgentProfileAskQuestion.types';
import ChatFill from 'sly/icons/ChatFill';
import { Button } from 'sly/system';

export default function AgentProfileAskQuestion({
  buttonHref,
}: AgentProfileAskQuestionProps) {
  return (
    <div
      className='hidden max-w-[131px] md:items-center md:justify-between lg:block lg:flex'
      data-tp-id='gen-div-650ab83b-c580-4eec-a85a-50f7f99f304f'
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*@ts-ignore*/}
      <Button
        className='mb-6 mb-0 w-full px-s md:w-auto'
        href={buttonHref}
        data-tp-id='gen-Button-b3004e06-55f0-4ea2-847a-3cbf428ec327'
      >
        {/*TODO remove with ICON refactor*/}
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <ChatFill className='mr-2' />
        Message
      </Button>
    </div>
  );
}
